"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledLink = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

const StyledLink = _styledComponents.default.a(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  text-decoration: none;\n  cursor: pointer;\n  color: ", ";\n  font-size: ", ";\n  ", ";\n"])), _ref => {
  let {
    color,
    theme
  } = _ref;
  return color || theme.color.font.primary;
}, _ref2 => {
  let {
    size,
    theme
  } = _ref2;
  return size || theme.font.size.md;
}, _ref3 => {
  var _theme$components, _theme$components$lin;

  let {
    theme
  } = _ref3;
  return theme === null || theme === void 0 ? void 0 : (_theme$components = theme.components) === null || _theme$components === void 0 ? void 0 : (_theme$components$lin = _theme$components.link) === null || _theme$components$lin === void 0 ? void 0 : _theme$components$lin.link;
});

exports.StyledLink = StyledLink;